import { render, staticRenderFns } from "./UnpublishedBox.vue?vue&type=template&id=15370320&scoped=true&"
import script from "./UnpublishedBox.vue?vue&type=script&lang=js&"
export * from "./UnpublishedBox.vue?vue&type=script&lang=js&"
import style0 from "./UnpublishedBox.vue?vue&type=style&index=0&id=15370320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15370320",
  null
  
)

export default component.exports